import m from "./../../../dist/es2015/locales/et_EE.js";
export const am5locales_et_EE = m;